import React, { useContext, useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import Fade from 'react-reveal/Fade';
import PortfolioContext from '../../context/context';
import TextLoop from "react-text-loop";
import Emoji from "../Header/Emoji";



const Header = () => {
  
  const { hero } = useContext(PortfolioContext);
  const { title, name, subtitle, cta } = hero;

  const [isDesktop, setIsDesktop] = useState(false);
  const [isMobile, setIsMobile] = useState(false);


  useEffect(() => {
    if (window.innerWidth > 769) {
      setIsDesktop(true);
      setIsMobile(false);
    } else {
      setIsMobile(true);
      setIsDesktop(false);
    }
  }, []);

  return (
   
    <section id="hero" className="jumbotron" >
    
      <Container>
        <Fade left={isDesktop} bottom={isMobile} duration={1000} delay={500} distance="30px" >
          <h1 className="hero-title">
            {title || 'Hi, Its'}{' '}
            <span className="text-color-main">{name || 'Ankur '}</span><Emoji symbol="🦸‍♂️" label="bug"/>
            <br/>
            <h1 className="hero-title">I'm a&nbsp;
            <TextLoop>
        <h1 className="hero-title">Developer<Emoji symbol=" 👨‍💻 💻" label="sheep"/>.</h1>
        <h1 className="hero-title" >Test Engineer <Emoji symbol=" 🕵🏼🐞" label="bug"/>.</h1>
        <h1 className="hero-title" > code enthusiast <Emoji symbol=" 🖖" label="handhi"/>.</h1>      
        <h1 className="hero-title" > creative <Emoji symbol="🙈🙉🙊" label="handhi"/>.</h1>      

     
      </TextLoop>{"  "}
          </h1>
          </h1>  
  
        </Fade>
        <Fade left={isDesktop} bottom={isMobile} duration={1000} delay={1000} distance="30px">
          <p className="hero-cta">
            <a className="cta-btn cta-btn--hero" href="#about">
              {cta || 'Know more'}  
            </a>
          </p>
        </Fade>
      </Container>
    </section>
  )
};

export default Header;
